<template>
    <v-radio-group v-model="model">
        <v-label>Itens Excluídos</v-label>
        <v-radio
            v-for="option in options"
            :key="option"
            :label="$t(`filters.labels.${option}`)"
            :value="option"
        ></v-radio>
    </v-radio-group>
</template>

<script>
export default {
    props: ['name', 'resource', 'options'],

    computed: {
        key() {
            return [this.resource, this.name].join('.')
        },
        model: {
            get() {
                return this.$store.getters['filters/getByDotNotation'](this.key)
            },
            set(value) {
                if (!value) {
                    this.$store.commit('filters/unset', {
                        resource: this.resource,
                        name: this.name,
                    })
                    return
                }

                this.$store.commit('filters/apply', {
                    resource: this.resource,
                    filter: { name: this.name, value: value },
                })
            },
        },
    },
}
</script>

<style></style>
